import { createContext, useRef, useContext, PropsWithChildren } from 'react';
import { useStore } from 'zustand';
import {
  createProductsStore,
  ProductState,
  ProductStore,
} from './products-store';

export type ProductStoreApi = ReturnType<typeof createProductsStore>;

export const ProductStoreContext = createContext<ProductStoreApi | undefined>(
  undefined,
);

export type ProductStoreProviderProps = PropsWithChildren<ProductState>;

export const ProductsStoreProvider = ({
  children,
  ...props
}: ProductStoreProviderProps) => {
  const storeRef = useRef<ProductStoreApi>();
  if (!storeRef.current) {
    storeRef.current = createProductsStore(props);
  }

  return (
    <ProductStoreContext.Provider value={storeRef.current}>
      {children}
    </ProductStoreContext.Provider>
  );
};

export const useProductStore = <T,>(
  selector: (store: ProductStore) => T,
): T => {
  const productStoreContext = useContext(ProductStoreContext);

  if (!productStoreContext) {
    throw new Error(`useStore must be used within ProductStoreProvider`);
  }

  return useStore(productStoreContext, selector);
};
